export const CHANGE_SIM_PROVIDER_REQUEST = "CHANGE_SIM_PROVIDER_REQUEST";
export const CHANGE_SIM_PROVIDER_RESULT = "CHANGE_SIM_PROVIDER_RESULT";
export const CHANGE_SIM_PROVIDER_OPEN_MODAL = "CHANGE_SIM_PROVIDER_OPEN_MODAL";
export const CHANGE_SIM_PROVIDER_CLOSE_MODAL = "CHANGE_SIM_PROVIDER_CLOSE_MODAL";
export const CHANGE_SIM_PROVIDER_GET_DEVICE_REQUEST = "CHANGE_SIM_PROVIDER_GET_DEVICE_REQUEST";
export const CHANGE_SIM_PROVIDER_GET_DEVICE_RESULT = "CHANGE_SIM_PROVIDER_GET_DEVICE_RESULT";

export const CHANGE_SIM_PROVIDER_SET_DEVICE = "CHANGE_SIM_PROVIDER_SET_DEVICE";

